import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export default function AppInfoGrid({
  children,
  columns = { xs: 1, sm: 2, md: 3 },
  rowGap = 2,
  columnGap = 2.75,
  gap,
  className,
  sx,
  ...props
}) {
  const getGridTemplateColumns = () => {
    if (typeof columns === "number") {
      return `repeat(${columns}, minmax(0, 1fr))`;
    }
    if (typeof columns === "object" && columns !== null) {
      const responsiveColumns = {};
      for (const [breakpoint, colCount] of Object.entries(columns)) {
        responsiveColumns[breakpoint] = `repeat(${colCount}, minmax(0, 1fr))`;
      }
      return responsiveColumns;
    }
    return "repeat(3, minmax(0, 1fr))";
  };

  return (
    <Box
      className={`app-info-grid ${className || ""}`.trim()}
      sx={{
        display: "grid",
        gridTemplateColumns: getGridTemplateColumns(),
        rowGap: gap ?? rowGap,
        columnGap: gap ?? columnGap,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}

AppInfoGrid.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  rowGap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  columnGap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  sx: PropTypes.object,
};
